<template>
  <div id="mybook" class="mybookMian">
    <div class="bookMianP" @click="didDenglu()">
      <div class="bookview">
        <div class="boomtview">
          <!-- <div class="boomthanS">
            <div class="boomtextN">日期</div>
            <div class="boomtext">主编</div>
          </div>
          <div class="boomthanX">
            <div class="boomtextN">{{ pageTime }}</div>
            <div class="boomtext">{{ fodername }}</div>
          </div> -->
        </div>

        <div class="book-textbok">
          <div class="book-text">{{homeName}}</div>
        </div>
      </div>
    </div>

    <div class="mypopup" v-if="password_show">
      <div class="content">
        <div class="close_btn" @click="closePop()">X</div>
        <div class="main">
          <h3>请输入家谱密码</h3>
          <p v-if="pssword_is" class="tip">密码错误,请重新输入</p>
          <div class="pwipt">
            <input
              type="password"
              @input="judgePassword"
              v-model="password"
              autofocus
              maxlength="6"
            />
            <div class="border-right">
              <span v-if="show1"></span>
            </div>
            <div class="border-right">
              <span v-if="show2"></span>
            </div>
            <div class="border-right">
              <span v-if="show3"></span>
            </div>
            <div class="border-right">
              <span v-if="show4"></span>
            </div>
            <div class="border-right">
              <span v-if="show5"></span>
            </div>
            <div>
              <span v-if="show6"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      autofocus: true,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      show6: false,
      pssword_is: false,
      password_show: false,
      homeName:"家谱"
    };
  },

  methods: {


    //获取名称
    gethomename: function () {
      // 调用密码校验接口
      let that = this;
      this.axios.post(this.COMMON.httpUrl + "go_home/getname").then((res) => {
        if (res.data.code == 1) {
            if(res.data.data.length >0){
             that.homeName = res.data.data;
           }
        }
        
      });
    },
    //获取数据

    didDenglu: function () {
      this.password  = localStorage.getItem("passwodr");
      if(this.password && this.password.length >0){
          this.surePassword();
      }else{
          this.password_show = true; 
      }
    
    },

    //关闭密码输入清空输入
    closePop: function () {
      this.password = "";
      this.judgePassword();
      this.password_show = false;
    },
    //校验密码
    surePassword: function () {
      // 调用密码校验接口
      let that = this;
      var prem = {
        pass_wode: this.password,
      };
      this.axios.post(this.COMMON.httpUrl + "go_home/gologin", prem).then((res) => {
        if (res.data.code == 1) {
            localStorage.setItem("passwodr",that.password);
           that.$router.push({ name: "gohome" });
        }else{
          that.password_show = true;
           that.pssword_is= true;
        }
      });
    },
    // 密码输入样式
    judgePassword: function () {
      if (this.password.length == 0) {
        this.show1 = false;
        this.show2 = false;
        this.show3 = false;
        this.show4 = false;
        this.show5 = false;
        this.show6 = false;
      }
      if (this.password.length == 1) {
        this.show1 = true;
        this.show2 = false;
        this.show3 = false;
        this.show4 = false;
        this.show5 = false;
        this.show6 = false;
      }
      if (this.password.length == 2) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = false;
        this.show4 = false;
        this.show5 = false;
        this.show6 = false;
      }
      if (this.password.length == 3) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = false;
        this.show5 = false;
        this.show6 = false;
      }
      if (this.password.length == 4) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = true;
        this.show5 = false;
        this.show6 = false;
      }
      if (this.password.length == 5) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = true;
        this.show5 = true;
        this.show6 = false;
      }
      if (this.password.length == 6) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = true;
        this.show5 = true;
        this.show6 = true;
        // 接口校验密码
        this.surePassword();
      }
    },
  },
  
  mounted: function () {
    
     localStorage.setItem("passwodrEit",0);
     this.gethomename()

  },

};
</script>

<style scoped>
.bookMian {
  width: 100%;
  height: 847px;
  padding-top: 20px;
  background-color: #ffffff;
  /*   border: 2px solid #333333;*/
  box-sizing: border-box;
}
.bookMianP {
  width: 100%;
  height: 847px;
  background: url(../assets/img/book.png) no-repeat;
}
.bookview {
  margin-top: 40rpx;
  margin-bottom: 10rpx;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.boomtview {
  margin-top: 520px;
  margin-left: 80px;
  font-size: 10px;
  color: #555555;
  border: 0.5px solid #666;
  background-color: whitesmoke;
}
.boomthanS {
  display: flex;
  flex-direction: row;
  height: 80px;
  border-bottom: 0.5px solid #666;
  font-size: 23px;
}
.boomtextN {
  padding-left: 3px;
  padding-top: 3px;
  width: 40px;
  align-items: center;
  writing-mode: sideways-rl;
  display: flex;
  align-items: center;
  text-align: center;
}
.book-textbok {
  padding-top: 100px;
  margin-right: 75px;
}
.book-text {
  text-align: center;
  color: #444444;
  width: 100px;
  font-size: 70px;
  font-family: "FangSong";
  font-style: italic;
  overflow: hidden;
  writing-mode: sideways-rl;
  word-break: break-word;
}
.boomtextN span {
  width: 6px;
  margin-left: 1px;
  line-height: 10px;
  text-align: center;
  word-break: break-word;
}
.boomtext {
  border-left: 1px solid #666;
  writing-mode: sideways-rl;
  padding-top: 3px;
  width: 40px;
  display: flex;
  align-items: center;
  text-align: center;
}
.boomthanX {
  display: flex;
  flex-direction: row;
  height: 200px;
  font-size: 23px;
}

.bookHedTop {
  width: 100%;
  height: 40px;
}

.mybookMian {
  width: 595.28px;
  margin: 0 auto;
  box-sizing: border-box;
  background: #ffffff;
}

/**输入框 */
.mypopup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.mypopup .content {
  position: relative;
  background: #fff;
  width: 300px;
  border-radius: 10px;
}
.mypopup .content .main {
  padding: 40px 30px;
  font-size: 12px;
  text-align: center;
}
.mypopup .content .main h3 {
  font-size: 18px;
  line-height: 2em;
  font-weight: 700;
}
.mypopup .content .main .tip {
  color: #ee4a4a;
  margin-bottom: 10px;
}
.mypopup .content .main .pwipt {
  font-size: 0;
  height: 45px;
  line-height: 45px;
  width: 220px;
  border: 1px solid #ccc;
  text-align: center;
}
.mypopup .content .main .pwipt div {
  display: inline-block;
  width: 16.2%;
  height: 45px;
  position: relative;
}
.mypopup .content .main .pwipt .border-right {
  border-right: 1px solid #ccc;
}
.mypopup .content .main .pwipt div > span {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #000;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  margin-top: -5px;
  margin-left: -5px;
}
.mypopup .content .main .pwipt input {
  outline: none;
  border: 0;
  background: none;
  width: 900px;
  height: 0;
  padding: 22px 0;
  text-align: center;
  position: absolute;
  left: -500px;
  right: 0;
  z-index: 1000;
  color: transparent;
  text-indent: -999em;
}
.mypopup .content .close_btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 14px;
  height: 14px;
  z-index: 1000;
}
.forgetpw {
  font-size: 14px;
  color: #008aff;
  margin-top: 10px;
  text-align: right;
}
</style>